import { render } from "./Creature.vue?vue&type=template&id=5aacdbc0"
import script from "./Creature.vue?vue&type=script&lang=js"
export * from "./Creature.vue?vue&type=script&lang=js"

import "./Creature.vue?vue&type=style&index=0&id=5aacdbc0&lang=scss"

import exportComponent from "D:\\repos\\rivendom-compendium\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__